import MenuItem from '@mui/material/MenuItem';

 const statusObrade = [

     {value:0 , name: "0-Čeka na knjiženje"},
     {value:1 , name: "1-Greška"},
     {value:2 , name: "2-Proknjiženo"	},
     {value:3 , name: "3-Forsira se"},
     {value:4 , name: "4-Ne diraj do daljnjeg"},
     {value:5 , name: "5-Višak, treba brisati"},
     {value:6 , name: "6-Ne znam riješiti"	}
 ]       


 const trebaLiSkloniti = [

     {value: 0, name: "0-Ostaje u spisku"},
     {value: 1, name: "1-Treba skloniti"},
     //{value: 2, name: "2-Interval: 1 umjesto 0"},
     //{value: 3, name: "3-Interval: 0 umjesto 1"},
     {value: 4, name: "4-Odgođeno za kasnije "},
     //{value: 5, name: "5-Interval: 4 umjesto 0"},
     //{value: 6, name: "6-Interval: 1 umjesto 4"}
 ]

 export const statusObradeOptions = statusObrade.map((item, index)=> {
    return (
        <MenuItem value={item.value}>{item.name}</MenuItem>
    )
 })

 export const trebaLiSklonitiOptions = trebaLiSkloniti.map((item, index)=> {
    return (
        <MenuItem value={item.value}>{item.name}</MenuItem>
    )
 })



 const TKC = 
 ["001 (01)Zagreb ",
 "020 (19)Dubrovnik",
 "021 (17)Split",
 "022 (15)Šibenik",
 "023 (13)Zadar",
 "031 (14)Osijek",
 "032 (16)Vukovar",
 "033 (10)Virovitica",
 "034 (11)Požega",
 "035 (12)Slav.Brod",
 "040 (20)Čakovec",
 "042 (05)Varaždin",
 "043 (07)Bjelovar",
 "044 (03)Sisak",
 "047 (04)Karlovac",
 "048 (06)Koprivnica",
 "049 (02)Krapina",
 "051 (08)Rijeka",
 "052 (18)Pula",
 "053 (09)Gospić"]